<template>
  <div class="file-card" :style="{ 'justify-content': isMobile() ? 'flex-end' : 'center' }">
    <VideoCard
      v-if="file.type === 'video'"
      :file="file.file"
      :uploading="file.uploading"
      :uploading-percent="file.uploadingPercent"
    />
    <AudioPlayerCard
      v-else-if="file.type === 'voice'"
      :add-time="file.addTime"
      :file="file.file"
      :is-medical-industry="file.isMedicalIndustry"
      :uploading="file.uploading"
      :uploading-percent="file.uploadingPercent"
    />
  </div>
</template>

<script setup>
import VideoCard from './VideoCard.vue'
import AudioPlayerCard from './AudioPlayerCard.vue'
import { isMobile } from '@/utils'

defineProps({
  file: {
    type: Object,
    required: true
  }
})
</script>

<style lang="less" scoped>
.file-card {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
</style>
